// extracted by mini-css-extract-plugin
export default {"root":"WeekCalendar_root__ITL1e","empty":"WeekCalendar_empty__rt8VI","todayTd":"WeekCalendar_todayTd__P5uz7","todayTh":"WeekCalendar_todayTh__iSatz"};